import { Doc, DocStatus } from 'types/entities'

import { useOnUpdateDocStatus } from 'state/docs/hooks'

import { useOpenModal } from 'modal'
import { newConfirmModal } from 'modals'
import { CellProps } from 'components/ui'
import { notifications } from 'constants/notifications'

import { useCallNotification } from 'notifications/hooks'
import { NotificationTypes } from 'notifications/service'

import { ButtonClose } from '../Style'

type Props = {
  content?: string
  updateData: () => Promise<void>
}

type AcceptProps = CellProps<Doc> & Props

export function AcceptVerification({ row, content, updateData }: AcceptProps) {
  const openModal = useOpenModal()
  const callNotification = useCallNotification()
  const { onUpdateDocStatus, ...request } = useOnUpdateDocStatus()

  const { id } = row.original

  const handleAccept = () => {
    openModal(newConfirmModal({ action: handleUpdateStatus }))
  }

  const handleUpdateStatus = async () => {
    try {
      await onUpdateDocStatus({ id, status: DocStatus.ACCEPTED })

      await updateData()
    } catch (err) {
      callNotification({ type: NotificationTypes.ERROR, message: notifications.errors.changeKycStatus(err.message) })
    }
  }

  return (
    <ButtonClose size='medium' loadingText='' onClick={handleAccept} isLoading={request.isLoading}>
      {content ? content : 'Accept'}
    </ButtonClose>
  )
}
